import Add from './Add';
import Update from './Update';
import UpdateMobile from './UpdateMobile';
import PageHeading from './PageHeading';
import Pagination from './Pagination';
import DynamicForm from './DynamicForm';

export { Add, Update, UpdateMobile, PageHeading, Pagination, DynamicForm };
